import { module as BaseModule } from 'modujs'
import SplitType from 'split-type'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.splitText()
    this.observer()

    window.addEventListener('resize', this.resize.bind(this))
  }

  splitText() {
    this.text = SplitType.create(this.el)
  }

  observer() {
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window
    ) {
      // Animate when in viewport
      this.controler = new IntersectionObserver(
        (entries, obs) => {
          entries.forEach((entry) => {
            if (this.text && entry.isIntersecting) {
              this.controler.unobserve(this.el)
              this.show()
            }
          })
        },
        { threshold: 0.1 }
      )
      this.controler.observe(this.el)
    } else {
      setTimeout(() => {
        this.show()
      }, 500)
    }
  }

  show() {
    this.el.classList.add('--reveal')

    this.text.lines.forEach((line, i) => {
      const chars = line.querySelectorAll('.char')
      chars.forEach((char, j) => {
        setTimeout(
          () => {
            char.classList.add('--show')
          },
          j * 20 + i * 400
        )
      })
    })
  }

  resize() {
    this.splitText()
    this.observer()
  }
}
